import {FC, useEffect, useRef, useState} from 'react';
import {
  CircleButtonBlockWrapper,
  CircleButtonWrapper,
  OverflowMenuItemWrapper,
  OverflowMenuWrapper,
} from '@atoms/CircleButton.styles';
import {OverflowMenuVertical} from '@carbon/icons-react';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {useOnClickOutside} from '@hooks/useOnClickOutside';

export interface CircleButtonProps {
  onClick?: () => void;
  menu?: {title: string; onClick: () => void; color?: string}[];
}

const CircleButton: FC<CircleButtonProps> = ({onClick, menu}) => {
  const [menuShow, setMenuShow] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Закрытие меню при клике вне меню
  useOnClickOutside(menuRef, () => setMenuShow(false));

  // Закрытие меню при нажатии Esc
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setMenuShow(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <CircleButtonBlockWrapper>
      <CircleButtonWrapper
        onClick={() => {
          setMenuShow(true);
          if (onClick) {
            onClick();
          }
        }}>
        <OverflowMenuVertical size={16} />
      </CircleButtonWrapper>
      {!!menu?.length && menuShow && (
        <OverflowMenuWrapper ref={menuRef} onMouseLeave={() => setMenuShow(false)}>
          {menu.map(menuItem => {
            return (
              <OverflowMenuItemWrapper key={menuItem.title} onClick={menuItem.onClick}>
                <Text
                  text={menuItem.title}
                  type="bodyM"
                  color={menuItem.color ? menuItem.color : theme.colors.accent00}
                />
              </OverflowMenuItemWrapper>
            );
          })}
        </OverflowMenuWrapper>
      )}
    </CircleButtonBlockWrapper>
  );
};

export default CircleButton;
